// Родительская оболочка (UI-UX 5): нижние вкладки на телефоне, навигационная рейка на планшете.
import { NavLink, Outlet } from "react-router";
import { useApp } from "../state/app.ts";
import { t } from "../i18n/ru.ts";

const tabs = [
  { to: "/today", label: t.tabs.today, icon: "M3 10l9-7 9 7v10a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z" },
  { to: "/catalog", label: t.tabs.catalog, icon: "M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z" },
  { to: "/guide", label: t.tabs.guide, icon: "M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2zM8 7h8M8 11h6" },
  { to: "/progress", label: t.tabs.progress, icon: "M4 20V10M10 20V4M16 20v-7M22 20H2" },
];

export function StatusBanners() {
  const { online, content, updateReady } = useApp();
  return (
    <>
      {!online ? <div className="banner banner--quiet" role="status">{t.common.offline}</div> : null}
      {content?.dev ? <div className="banner banner--dev" role="status">{t.common.devContent}</div> : null}
      {updateReady ? (
        <div className="banner" role="status">
          {t.common.updateReady}{" "}
          <button className="link" onClick={() => window.dispatchEvent(new Event("brovka:update"))}>
            {t.common.updateNow}
          </button>
        </div>
      ) : null}
    </>
  );
}

export function Shell() {
  return (
    <div className="shell">
      <nav className="nav" aria-label="Разделы">
        {tabs.map((x) => (
          <NavLink key={x.to} to={x.to} className={({ isActive }) => `nav__item${isActive ? " is-active" : ""}`}>
            <svg viewBox="0 0 24 24" width={24} height={24} aria-hidden="true">
              <path d={x.icon} fill="none" stroke="currentColor" strokeWidth={2} strokeLinejoin="round" strokeLinecap="round" />
            </svg>
            <span>{x.label}</span>
          </NavLink>
        ))}
      </nav>
      <main className="shell__main">
        <StatusBanners />
        <Outlet />
      </main>
    </div>
  );
}

export function TopBar({ title, back, actions }: { title: string; back?: () => void; actions?: React.ReactNode }) {
  return (
    <header className="topbar">
      {back ? (
        <button className="icon-btn" onClick={back} aria-label={t.common.back}>
          <svg viewBox="0 0 24 24" width={24} height={24} aria-hidden="true">
            <path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round" />
          </svg>
        </button>
      ) : null}
      <h1 className="topbar__title">{title}</h1>
      <div className="topbar__actions">{actions}</div>
    </header>
  );
}
